<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费类型：</span>
        </div>
        <el-select v-model="formData.chargeType" size="small" style="width: 280px">
          <el-option v-for="item in chargeTypeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费项名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>      

      <!-- <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费金额：</span>
        </div>
        <el-input v-model="formData.money" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div> -->

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费模式：</span>
        </div>
        <el-select v-model="formData.chargeMode" size="small" style="width: 280px">
          <el-option v-for="item in chargingModeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">凭证类型：</span>
        </div>
        <el-select v-model="formData.type" size="small" style="width: 280px">
          <el-option v-for="item in documentTypeList" :key="item.code"
                     :label="item.mchName" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">收费规则说明：</span>
        </div>
        <el-input v-model="formData.introduction" type="textarea" size="small" style="width: 280px" />
      </div>      

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import $ from "jquery";
import { api } from "../../api/CustomPayment";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
import UploadImgList from "../../../components/Input/UploadImgList";

export default {
  components: {
    UploadImgList,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "charge-items-management-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "收费项管理"
        }
      ],
      mainTitle: "修改收费项",
      subheading: "",

      formData: {
        chargeType: "",
        name: "",
        money: "",
        chargeMode: "",
        type: ""
      },
      chargeTypeList: [
        { code: "个人", name: "个人" },
        { code: "租户", name: "租户" }
      ],
      chargingModeList: [
        { code: "经办人代收", name: "经办人代收" },
        { code: "财务收款", name: "财务收款" }
      ],
      documentTypeList: [
        { code: "发票", name: "发票" },
        { code: "收据", name: "收据" }
      ],
      accountList: [],
      responsiblePersonList: []
    };
  },
  created() {
    this.getPaymentItemByCode();
  },
  methods: {
    getPaymentItemByCode() {
      this.$axios
        .get(`${api.getPaymentItemByCode}/${this.$route.params.id}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            console.log(data);
            this.formData = data;
            // console.log(this.formData);
          }
        })
        .catch(errorHandler("查询失败"));
    },
    toManagePage() {
      this.$router.push({
        name: "charge-items-management"
      });
    },

    confirm() {
      if (!this.formData.chargeType) {
        nError("请选择收费类型");
        return false;
      }
      if (!this.formData.name) {
        nError("请输入收费项名称");
        return false;
      }
      if (!this.formData.chargeMode) {
        nError("请选择收费模式");
        return false;
      }
      if (!this.formData.type) {
        nError("请选择凭证类型");
        return false;
      }
      this.$axios
        .post(api.updatePaymentItem, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.toManagePage();
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.toManagePage();
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 36px;
  line-height: 120px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 50px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 250px;
  height: 173px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: 0.7;
}
</style>

<style lang="less">
.el-switch {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/ChargeItemsManagement/ChargeItemsManagementModify.vue